import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Header, Button, Modal } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'

import { removeZendeskSatisfactionSync } from 'actions'

const RemoveButton = ({ handleOnClick }) => (
  <Button
    negative
    onClick={handleOnClick}
    className="remove-integration ml3"
    style={{ whiteSpace: 'nowrap', alignSelf: 'center' }}
  >
    Remove integration
  </Button>
)

RemoveButton.propTypes = {
  handleOnClick: PropTypes.func,
}

class RemoveIntegration extends React.Component {
  static propTypes = {
    companyId: PropTypes.number,
    removeZendeskSatisfactionSync: PropTypes.func,
    history: PropTypes.object,
    replace: PropTypes.func,
  }

  state = { modalOpen: false }

  handleOpen = () => {
    this.setState({ modalOpen: true })
  }

  handleClose = () => {
    this.setState({ modalOpen: false })
  }

  handleOnClick = () => {
    this.setState({ modalOpen: false })
    this.props.removeZendeskSatisfactionSync(this.props.companyId)
    this.props.history.replace('/settings/integrations')
  }

  render() {
    return (
      <div className="ui message flex">
        <div>
          <div className="header">Remove Integration</div>
          <p>
            After removing this integration new ratings will not be imported, but old ones will stay
            in Simplesat.
          </p>
        </div>
        <Modal
          trigger={<RemoveButton handleOnClick={this.handleOpen} />}
          open={this.state.modalOpen}
          onClose={this.handleClose}
          size="small"
        >
          <Header content="Remove Integration" />
          <Modal.Content>
            <p>Are you sure you want to remove the Zendesk integration?</p>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleClose}>Cancel</Button>
            <Button color="red" onClick={this.handleOnClick}>
              Remove
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}

const mapDispatch = (dispatch) => ({
  removeZendeskSatisfactionSync: (companyId) => dispatch(removeZendeskSatisfactionSync(companyId)),
})

export default withRouter(connect(null, mapDispatch)(RemoveIntegration))



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Integrations/ZendeskSatisfaction/RemoveIntegration.js